export const header = {
    state: {
        showMobileMenu: false
    },
    mutations: {
        SET_MOBILE_MENU(state, payload) {
            state.showMobileMenu = payload
        }
    },
    actions: {
        toggleMobileMenu({ state, commit }, payload = null) {
            let toggle
            if (payload === null) {
                toggle = !state.showMobileMenu
            } else {
                toggle = payload
            }
            commit('SET_MOBILE_MENU', toggle)
        }
    },
    getters: {
        getShowMobileMenu: (state) => {
            return state.showMobileMenu
        }
    }
}